import { Dictionary, NlpModelId, SocketId, UserId, UserRole } from '@feedyou-ai/feedbot-schema'
import { ActiveRunInfo, IndexingRunProgress } from '@feedyou/utils'

export interface BotState {
  diff?: string
  botVersion?: string
  lastUpdated?: number
  authorSocketId?: string
  editingUsers?: EditingUsers
  sequenceNumber: number
  subSequenceNumber: number

  botTester: {
    runningTests: ActiveRunInfo<any>[]
  }
}

export type EditingUsers = Dictionary<UserId, ConnectedSocketUser>

export interface RoomState {
  connectedUsers: Dictionary<SocketId, ConnectedSocketUser>
  botState: BotState
  isDeploying?: boolean
  isLaunching?: boolean
  isUpdating?: boolean
  isMigratingMediaGallery?: boolean
  hostingError?: string
  lastVersion?: string
  exclusiveUiUser: {
    socketId: SocketId
    userId: UserId
  } | null
  kbIndexing: {
    activeRuns: Dictionary<NlpModelId, IndexingRunProgress>
  }
}

export interface ConnectedSocketUser {
  id?: string
  email?: string
  name?: string
  picture?: string
  role?: 'guest' | UserRole | 'admin'
}

export enum HostingStatus {
  PAUSED = 'hosting-paused',
  RESUME = 'hosting-resume'
}

export interface SocketServerState {
  isConnected: boolean
  isBotStateUpToDate: boolean
  roomState?: RoomState
  socketId: string | null
}

export enum SocketServerEvent {
  ROOM_STATE = 'room-state',
  COMMENTS_CHANGE = 'comments-change',
  NEW_VERSION = 'new-version',
  RELOAD_BOT = 'reload-bot',
  DEPLOY_BOT_FAILURE = 'deploy-bot-failure',
  DEPLOY_BOT_SUCCESS = 'deploy-bot-success',
  SYNC_ERROR = 'sync-error',
  UPDATE_HOSTING_DONE = 'update-hosting-done',
  NEW_EDITING_USER = 'new-editing-user',
  BOT_TESTER_SCENARIO_FINISH = 'bot-tester-scenario-finish',
  UPDATE_BOT_CONFIGURATION = 'update-bot-configuration',
  KB_INDEXING_DONE = 'indexing-done'
}

export enum SocketClientEvent {
  BOT_STATE = 'bot-state',
  COMMENTS_CHANGE = 'comments-change',
  NEW_VERSION = 'new-version',
  JOIN_EDITING = 'join-editing',
  OPEN_EXCLUSIVE_UI = 'open-exclusive-ui',
  CLOSE_EXCLUSIVE_UI = 'close-exclusive-iu'
}

export interface LockedState {
  isLocked: boolean
  editingUsers?: EditingUsers
}
